import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class Base extends RESTSerializer {
  payloadKeyFromModelName(modelName) {
    return super.payloadKeyFromModelName(modelName).replace(/^finance\//, '');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey('finance/' + key);
  }
}
